export enum CaseStatuses {
  INVALID_CASE_STATUS = "INVALID_CASE_STATUS",
  DRAFT = "DRAFT",
  PROCESSING = "PROCESSING",
  CANCELED = "CANCELED",
  CLOSED = "CLOSED",
  COMPLETED = "COMPLETED",
}
